import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { StatisticsByReferralTable } from './StatisticsByReferralTable.js';
import {
    mainSelector,
    getHeaderName,
    getMetrics,
    getKeysMetric
} from './StatisticsByReferralTable.selectors';

const mapStateToPropsSelectors = createStructuredSelector({
    data: mainSelector,
    headerName: getHeaderName,
    metrics: getMetrics,
    keysMetric: getKeysMetric
});

const StatisticsByReferralTableComponent = connect(
    function mapStateToProps(state) {
        return {
            ...mapStateToPropsSelectors(state),
            loading: state.statistics.data.loading,
            rowsCount: state.statistics.data.rows ? state.statistics.data.rows.length : 0
        };
    },
    function mapDispatchToProps(dispatch) {
        return {
        };
    }
)(StatisticsByReferralTable);

export default StatisticsByReferralTableComponent;
